import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';

@Injectable()
export class DataService {
  
  private commentsSource = new BehaviorSubject(false);
  currentComments = this.commentsSource.asObservable();
  
  constructor() {
  }
  
  changeComments(state: boolean) {
    this.commentsSource.next(state);
  }
}
